<template>
  <v-container class="relative container1400">
    <h2 class="text-h5 mt-6 mb-6 font-weight-regular text-left">
      {{ $t("Cmsg10") }}
    </h2>
    <v-form
      ref="form"
      class="pb-5"
      v-model="valid"
      @submit.prevent="next"
      lazy-validation
    >
      <v-card class="pa-7" min-height="500px">
        <v-row>
          <v-col cols="6">
            <v-text-field
              hide-details="auto"
              v-bind:label="$t('Addressline1')"
              :rules="reqRules"
              v-model="data.address.address1"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              hide-details="auto"
              v-bind:label="$t('Addressline2')"
              v-model="data.address.address2"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field
              hide-details="auto"
              v-bind:label="$t('City')"
              :rules="reqRules"
              v-model="data.address.city"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              hide-details="auto"
              v-bind:label="$t('Statesprovinces')"
              :rules="reqRules"
              v-model="data.address.statesprovinces"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              hide-details="auto"
              v-bind:label="$t('ZIPPostalcode')"
              :rules="reqRules"
              v-model="data.address.postalcode"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-select
              :items="countries"
              item-text="country"
              v-bind:label="$t('Country')"
              :rules="reqRules"
              hide-details="auto"
              outlined
              return-object
              @change="handlePrimaryCountry"
            ></v-select>
          </v-col>
        </v-row>
        <div class="pt-5 overline">
          {{ $t("HowToGetThere") }}
        </div>
        <v-row>
          <v-col>
            <div>
              <vue-editor
                v-model="data.property_route"
                :editor-toolbar="customToolbar"
              />
            </div>
          </v-col>
        </v-row>
      </v-card>
      <div class="text-right mt-10">
        <v-btn
          outlined
          color="grey"
          large
          class="mr-2"
          @click="$emit('goBack')"
          >{{ $t("Back") }}</v-btn
        >
        <v-btn large color="light-blue white--text" rounded type="submit">
          <span class="mr-2">{{ $t("Continue") }}</span>
          <v-icon size="small">mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Countries from "@/assets/countries.json";

export default {
  props: ["data"],
  name: "Step3Component",
  components: { VueEditor },
  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ],
      valid: null,
      countries: Countries,
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  methods: {
    handlePrimaryCountry(e) {
      this.data.address.country = e.country;
      this.data.price.currencyCode = e.currency;
      this.data.position = [e.lng, e.lat];
    },
    async next() {
      await this.$refs.form.validate();
      if (this.valid) {
        window.scrollTo(0, 0);
        return (this.data.steps = 4);
      }
    }
  }
};
</script>

<style>
.ap-input {
  padding-left: 50px;
}
</style>
